import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

export const InclusionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 5px 15px;
`

export const AmenityTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  p {
    margin: 0;
    font-weight: 400;
    &.semibold {
      font-weight: semibold;
    }
  }
`

export const Inclusion = styled.span`
  color: ${({ theme }) => theme.colors?.textColor};
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  &.bold {
    font-weight: 600;
  }

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: calc(${BREAKPOINT_SM})) {
    font-size: 14px;
  }
`

export const SeeAmenities = styled.span`
  margin: 0;
  font-weight: 600;
  font-size: 10px;
  color: #9c9c9c;
  cursor: pointer;
`

export const DividerContainer = styled.span`
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`
